import React from 'react';
import { ReactDataTable } from '@metarouter-private/mr-mui';
import useSchemaViolationsDetailsTable from './useSchemaViolationsDetailsTable';

export default function SchemaViolationsDetailsTable() {
  const props = useSchemaViolationsDetailsTable();
  return <ReactDataTable {...props} />;
}
